<template>
    <div>
        <div id="threeWave" :style="divStyle" class="scrollbar"></div>
        <script type="x-shader/x-vertex" id="vertexshader">
			attribute float scale;
			void main() {
				vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
				gl_PointSize = scale * ( 300.0 / - mvPosition.z );
				gl_Position = projectionMatrix * mvPosition;
			}
		</script>

		<script type="x-shader/x-fragment" id="fragmentshader">
			uniform vec3 color;
			void main() {
				if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;
				gl_FragColor = vec4( color, 1.0 );
			}
		</script>
    </div>
</template>
<script>
    import * as THREE from 'three'
    export default {
        computed: {
            divStyle() {
                var style = {};
                style.width = this.width + 'px';
                style.height = this.height + 'px';
                style.backgroundImage = 'url('+ require('./waveBg.png') + ')';
                style.backgroundSize = '100% 99.9%';
                return style;
            }
        },
        data() {
            return {
                camera: null,
                scene: null,
                renderer: null,
                group: null,
                particles: 0,
                count: 0,
                container: null,
                SEPARATION: 100,
                AMOUNTX: 50,
                AMOUNTY: 50,
                mouseX: 0,
                mouseY: 0,
                windowHalfX: window.innerWidth / 2,
                windowHalfY: window.innerHeight / 2,
                width: window.innerWidth,
                height: window.innerHeight,
                d3g: {}
            }
        },
        mounted(){
            //$("div#intro .head")
            this.d3threeD();
            this.init();
            this.animate();
        },
        methods: {
            // From d3-threeD.js
            /* This Source Code Form is subject to the terms of the Mozilla Public
             * License, v. 2.0. If a copy of the MPL was not distributed with this file,
             * You can obtain one at http://mozilla.org/MPL/2.0/. */
            d3threeD() {
                var DEGS_TO_RADS = Math.PI / 180;
                var DIGIT_0 = 48,
                    DIGIT_9 = 57,
                    COMMA = 44,
                    SPACE = 32,
                    PERIOD = 46,
                    MINUS = 45;
                this.d3g.transformSVGPath = function transformSVGPath(pathStr) {
                    var path = new THREE.ShapePath();
                    var idx = 1,
                        len = pathStr.length,
                        activeCmd,
                        x = 0,
                        y = 0,
                        nx = 0,
                        ny = 0,
                        firstX = null,
                        firstY = null,
                        x1 = 0,
                        x2 = 0,
                        y1 = 0,
                        y2 = 0,
                        rx = 0,
                        ry = 0,
                        xar = 0,
                        laf = 0,
                        sf = 0,
                        cx, cy;

                    function eatNum() {
                        var sidx, c, isFloat = false,
                            s;
                        // eat delims
                        while (idx < len) {
                            c = pathStr.charCodeAt(idx);
                            if (c !== COMMA && c !== SPACE) break;
                            idx++;
                        }
                        if (c === MINUS) {
                            sidx = idx++;
                        } else {
                            sidx = idx;
                        }
                        // eat number
                        while (idx < len) {
                            c = pathStr.charCodeAt(idx);
                            if (DIGIT_0 <= c && c <= DIGIT_9) {
                                idx++;
                                continue;
                            } else if (c === PERIOD) {
                                idx++;
                                isFloat = true;
                                continue;
                            }
                            s = pathStr.substring(sidx, idx);
                            return isFloat ? parseFloat(s) : parseInt(s);
                        }
                        s = pathStr.substring(sidx);
                        return isFloat ? parseFloat(s) : parseInt(s);
                    }

                    function nextIsNum() {
                        var c;
                        // do permanently eat any delims...
                        while (idx < len) {
                            c = pathStr.charCodeAt(idx);
                            if (c !== COMMA && c !== SPACE) break;
                            idx++;
                        }
                        c = pathStr.charCodeAt(idx);
                        return (c === MINUS || (DIGIT_0 <= c && c <= DIGIT_9));
                    }
                    var canRepeat;
                    activeCmd = pathStr[0];
                    while (idx <= len) {
                        canRepeat = true;
                        switch (activeCmd) {
                            // moveto commands, become lineto's if repeated
                            case 'M':
                                x = eatNum();
                                y = eatNum();
                                path.moveTo(x, y);
                                activeCmd = 'L';
                                firstX = x;
                                firstY = y;
                                break;
                            case 'm':
                                x += eatNum();
                                y += eatNum();
                                path.moveTo(x, y);
                                activeCmd = 'l';
                                firstX = x;
                                firstY = y;
                                break;
                            case 'Z':
                            case 'z':
                                canRepeat = false;
                                if (x !== firstX || y !== firstY) path.lineTo(firstX, firstY);
                                break;
                                // - lines!
                            case 'L':
                            case 'H':
                            case 'V':
                                nx = (activeCmd === 'V') ? x : eatNum();
                                ny = (activeCmd === 'H') ? y : eatNum();
                                path.lineTo(nx, ny);
                                x = nx;
                                y = ny;
                                break;
                            case 'l':
                            case 'h':
                            case 'v':
                                nx = (activeCmd === 'v') ? x : (x + eatNum());
                                ny = (activeCmd === 'h') ? y : (y + eatNum());
                                path.lineTo(nx, ny);
                                x = nx;
                                y = ny;
                                break;
                                // - cubic bezier
                            case 'C':
                                x1 = eatNum();
                                y1 = eatNum();
                            case 'S':
                                if (activeCmd === 'S') {
                                    x1 = 2 * x - x2;
                                    y1 = 2 * y - y2;
                                }
                                x2 = eatNum();
                                y2 = eatNum();
                                nx = eatNum();
                                ny = eatNum();
                                path.bezierCurveTo(x1, y1, x2, y2, nx, ny);
                                x = nx;
                                y = ny;
                                break;
                            case 'c':
                                x1 = x + eatNum();
                                y1 = y + eatNum();
                            case 's':
                                if (activeCmd === 's') {
                                    x1 = 2 * x - x2;
                                    y1 = 2 * y - y2;
                                }
                                x2 = x + eatNum();
                                y2 = y + eatNum();
                                nx = x + eatNum();
                                ny = y + eatNum();
                                path.bezierCurveTo(x1, y1, x2, y2, nx, ny);
                                x = nx;
                                y = ny;
                                break;
                                // - quadratic bezier
                            case 'Q':
                                x1 = eatNum();
                                y1 = eatNum();
                            case 'T':
                                if (activeCmd === 'T') {
                                    x1 = 2 * x - x1;
                                    y1 = 2 * y - y1;
                                }
                                nx = eatNum();
                                ny = eatNum();
                                path.quadraticCurveTo(x1, y1, nx, ny);
                                x = nx;
                                y = ny;
                                break;
                            case 'q':
                                x1 = x + eatNum();
                                y1 = y + eatNum();
                            case 't':
                                if (activeCmd === 't') {
                                    x1 = 2 * x - x1;
                                    y1 = 2 * y - y1;
                                }
                                nx = x + eatNum();
                                ny = y + eatNum();
                                path.quadraticCurveTo(x1, y1, nx, ny);
                                x = nx;
                                y = ny;
                                break;
                                // - elliptical arc
                            case 'A':
                                rx = eatNum();
                                ry = eatNum();
                                xar = eatNum() * DEGS_TO_RADS;
                                laf = eatNum();
                                sf = eatNum();
                                nx = eatNum();
                                ny = eatNum();
                                if (rx !== ry) console.warn('Forcing elliptical arc to be a circular one:', rx, ry);
                                // SVG implementation notes does all the math for us! woo!
                                // http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
                                // step1, using x1 as x1'
                                x1 = Math.cos(xar) * (x - nx) / 2 + Math.sin(xar) * (y - ny) / 2;
                                y1 = -Math.sin(xar) * (x - nx) / 2 + Math.cos(xar) * (y - ny) / 2;
                                // step 2, using x2 as cx'
                                var norm = Math.sqrt((rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) /
                                    (rx * rx * y1 * y1 + ry * ry * x1 * x1));
                                if (laf === sf) norm = -norm;
                                x2 = norm * rx * y1 / ry;
                                y2 = norm * -ry * x1 / rx;
                                // step 3
                                cx = Math.cos(xar) * x2 - Math.sin(xar) * y2 + (x + nx) / 2;
                                cy = Math.sin(xar) * x2 + Math.cos(xar) * y2 + (y + ny) / 2;
                                var u = new THREE.Vector2(1, 0);
                                var v = new THREE.Vector2((x1 - x2) / rx, (y1 - y2) / ry);
                                var startAng = Math.acos(u.dot(v) / u.length() / v.length());
                                if (((u.x * v.y) - (u.y * v.x)) < 0) startAng = -startAng;
                                // we can reuse 'v' from start angle as our 'u' for delta angle
                                u.x = (-x1 - x2) / rx;
                                u.y = (-y1 - y2) / ry;
                                var deltaAng = Math.acos(v.dot(u) / v.length() / u.length());
                                // This normalization ends up making our curves fail to triangulate...
                                if (((v.x * u.y) - (v.y * u.x)) < 0) deltaAng = -deltaAng;
                                if (!sf && deltaAng > 0) deltaAng -= Math.PI * 2;
                                if (sf && deltaAng < 0) deltaAng += Math.PI * 2;
                                path.absarc(cx, cy, rx, startAng, startAng + deltaAng, sf);
                                x = nx;
                                y = ny;
                                break;
                            default:
                                throw new Error('Wrong path command: ' + activeCmd);
                        }
                        // just reissue the command
                        if (canRepeat && nextIsNum()) continue;
                        activeCmd = pathStr[idx++];
                    }
                    return path;
                };
            },
            /// Part from g0v/twgeojson
            /// Graphic Engine and Geo Data Init Functions
            addGeoObject(group, svgObject) {
                var paths = svgObject.paths;
                var depths = svgObject.depths;
                var colors = svgObject.colors;
                var center = svgObject.center;
                for (var i = 0; i < paths.length; i++) {
                    var path = this.d3g.transformSVGPath(paths[i]);
                    var color = new THREE.Color(colors[i]);
                    var material = new THREE.MeshLambertMaterial({
                        color: color,
                        emissive: color
                    });
                    var depth = depths[i];
                    var simpleShapes = path.toShapes(true);
                    for (var j = 0; j < simpleShapes.length; j++) {
                        var simpleShape = simpleShapes[j];
                        var shape3d = new THREE.ExtrudeBufferGeometry(simpleShape, {
                            depth: depth,
                            bevelEnabled: false
                        });
                        var mesh = new THREE.Mesh(shape3d, material);
                        mesh.rotation.x = Math.PI;
                        mesh.translateZ(-(0.5 * depth));
                        mesh.translateX(-center.x);
                        mesh.translateY(-center.y);
                        group.add(mesh);
                    }
                }
            },
            // if ( WebGL.isWebGLAvailable() === false ) {
            //     document.body.appendChild( WEBGL.getWebGLErrorMessage() );
            // }
            init() {
                this.container = document.getElementById('threeWave');
                this.camera = new THREE.PerspectiveCamera(75, this.width / this.height, 1, 10000);
                this.camera.position.z = 1000;
                this.scene = new THREE.Scene();
                
                // var loader = new THREE.ImageLoader();  //图片加载器
                // var texture = new THREE.Texture();
                // loader.load('./timg.jpg', function(image) {
                //     texture.image = image;
                //     texture.needsUpdate = true;
                //     console.log(texture);
                // });
                // this.scene.background = texture;
                // console.log(this.scene);
                //this.scene.background = new THREE.Color(0x141a48);
                //
                var directionalLight = new THREE.DirectionalLight(0x888888, 0.6);
                directionalLight.position.set(0.75, 0.75, 1.0).normalize();
                this.scene.add(directionalLight);
                this.group = new THREE.Group();
                this.scene.add(this.group);
                var obj = this.initSVGObject();
                this.addGeoObject(this.group, obj);
                var numParticles = this.AMOUNTX * this.AMOUNTY;
                var positions = new Float32Array(numParticles * 3);
                var scales = new Float32Array(numParticles);
                var i = 0,
                    j = 0;
                for (var ix = 0; ix < this.AMOUNTX; ix++) {
                    for (var iy = 0; iy < this.AMOUNTY; iy++) {
                        positions[i] = ix * this.SEPARATION - ((this.AMOUNTX * this.SEPARATION) / 2); // x
                        positions[i + 1] = 0; // y
                        positions[i + 2] = iy * this.SEPARATION - ((this.AMOUNTY * this.SEPARATION) / 2); // z
                        scales[j] = 1;
                        i += 3;
                        j++;
                    }
                }
                var geometry = new THREE.BufferGeometry();
                geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3));
                geometry.addAttribute('scale', new THREE.BufferAttribute(scales, 1));
                var material = new THREE.ShaderMaterial({
                    uniforms: {
                        color: {
                            value: new THREE.Color(0x5cadff)
                        },
                    },
                    vertexShader: document.getElementById('vertexshader').textContent,
                    fragmentShader: document.getElementById('fragmentshader').textContent
                });
                //
                this.particles = new THREE.Points(geometry, material);
                this.scene.add(this.particles);
                
                this.renderer = new THREE.WebGLRenderer({
                    antialias: true,
                    alpha: true
                });
                this.renderer.setClearColor(0xEEEEEE, 0.0);
                this.renderer.setPixelRatio(window.devicePixelRatio);
                this.renderer.setSize(this.width, this.height);
                this.container.appendChild(this.renderer.domElement);
                //stats = new Stats();
                //container.appendChild( stats.dom );
                document.addEventListener('mousemove', this.onDocumentMouseMove, false);
                document.addEventListener('touchstart', this.onDocumentTouchStart, false);
                document.addEventListener('touchmove', this.onDocumentTouchMove, false);
                //
                window.addEventListener('resize', this.onWindowResize, false);
            },
            initSVGObject() {
                var obj = {};
                /// The geo data from Taipei City, Keelung City, Taipei County in SVG form
                obj.paths = [
                    "M262.5523,145.1422 L241.1963,178.3937 L215.6549,208.5496 L186.3713,235.0866 L153.8537,257.5442 L118.6663,275.5328 L81.4197,288.7401 L42.7603,296.9370 L3.3588,299.9812 " +
                    "L-36.1009,297.8200 L-74.9342,290.4907 L-112.4671,278.1207 L-148.0485,260.9246 L-181.0608,239.2007 L-210.9313,213.3260 L-237.1415,183.7496 L-259.2367,150.9846 " +
                    "L-276.8334,115.5996 L-289.6263,78.2087 L-297.3934,39.4606 L-300.0000,0.0278 L-297.4008,-39.4055 L-289.6408,-78.1550 L-276.8548,-115.5483 L-259.2647,-150.9365 " +
                    "L-237.1756,-183.7056 L-210.9708,-213.2869 L-181.1052,-239.1671 L-148.0969,-260.8971 L-112.5187,-278.0999 L-74.9880,-290.4768 L-36.1561,-297.8133 L3.3032,-299.9818 " +
                    "L42.7052,-296.9449 L81.3662,-288.7552 L118.6152,-275.5548 L153.8060,-257.5728 L186.3278,-235.1212 L215.6163,-208.5896 L241.1633,-178.4385 L262.5254,-145.1909 " +
                    "L219.0252,-98.1222 L203.6961,-126.9169 L184.6038,-153.3670 L162.1011,-176.9837 L136.6038,-197.3307 L108.5827,-214.0322 L78.5557,-226.7796 L47.0774,-235.3375 L14.7294,-239.5476 " +
                    "L-17.8907,-239.3322 L-50.1804,-234.6954 L-81.5429,-225.7227 L-111.3990,-212.5800 L-139.1971,-195.5100 L-164.4237,-174.8281 L-186.6126,-150.9164 L-205.3540,-124.2166 " +
                    "L-220.3016,-95.2219 L-231.1793,-64.4682 L-237.7861,-32.5234 L-240.0000,0.0222 L-237.7801,32.5675 L-231.1673,64.5110 L-220.2839,95.2628 L-205.3309,124.2546 " +
                    "L-186.5846,150.9509 L-164.3913,174.8586 L-139.1609,195.5358 L-111.3596,212.6006 L-81.5011,225.7378 L-50.1369,234.7047 L-17.8464,239.3356 L14.7738,239.5449 " +
                    "L47.1210,235.3287 L78.5977,226.7651 L108.6224,214.0121 L136.6403,197.3054 L162.1339,176.9536 L184.6322,153.3328 L203.7196,126.8792 L219.0434,98.0816 " +
                    "Z",
                    "M264.5166,-129.3781 L281.1529,-106.7113 L294.4461,-81.9354 L304.1335,-55.5402 L310.0236,-28.0472 L312.0000,0.0000 " +
                    "L310.0236,28.0472 L304.1335,55.5402 L294.4461,81.9354 L281.1529,106.7113 L264.5166,129.3781 " +
                    "L264.4834,129.3781 L247.8471,106.7113 L234.5539,81.9354 L224.8665,55.5402 L218.9764,28.0472 L217.0000,0.0000 " +
                    "L218.9764,-28.0472 L224.8665,-55.5402 L234.5539,-81.9354 L247.8471,-106.7113 L264.4834,-129.3781 " +
                    "Z"
                ];
                obj.depths = [60, 60, 60];
                obj.colors = [0x0181B2, 0xABCD05, 0x182350];
                obj.center = {
                    x: 0,
                    y: 400
                };
                return obj;
            },

            onWindowResize() {
                this.windowHalfX = this.width / 2;
                this.windowHalfY = this.height / 2;
                this.camera.aspect = this.width / this.height;
                this.camera.updateProjectionMatrix();
                this.renderer.setSize(this.width, this.height);
            },
            //
            onDocumentMouseMove(event) {
                this.mouseX = event.clientX - this.windowHalfX;
                this.mouseY = event.clientY - this.windowHalfY;
            },

//             onDocumentTouchStart(event) {
//                 if (event.touches.length === 1) {
//                     event.preventDefault();
//                     mouseX = event.touches[0].pageX - windowHalfX;
//                     mouseY = event.touches[0].pageY - windowHalfY;
//                 }
//             },
// 
//             onDocumentTouchMove(event) {
//                 if (event.touches.length === 1) {
//                     event.preventDefault();
//                     mouseX = event.touches[0].pageX - windowHalfX;
//                     mouseY = event.touches[0].pageY - windowHalfY;
//                 }
//             },
            //
            animate() {
                requestAnimationFrame(this.animate);
                this.render();
                //stats.update();
            },
            render() {
                this.group.rotation.y += 0.006;
                this.camera.position.x = - this.width / 2;
                //this.camera.position.y += ( - this.mouseY - this.camera.position.y ) * .05;
                this.camera.position.y = 600;
                this.camera.lookAt(0,0,0);
                var positions = this.particles.geometry.attributes.position.array;
                var scales = this.particles.geometry.attributes.scale.array;
                var i = 0,
                    j = 0;
                for (var ix = 0; ix < this.AMOUNTX; ix++) {
                    for (var iy = 0; iy < this.AMOUNTY; iy++) {
                        positions[i + 1] = (Math.sin((ix + this.count) * 0.3) * 50) +
                            (Math.sin((iy + this.count) * 0.5) * 50);
                        scales[j] = (Math.sin((ix + this.count) * 0.3) + 1) * 8 +
                            (Math.sin((iy + this.count) * 0.5) + 1) * 8;
                        i += 3;
                        j++;
                    }
                }
                this.particles.geometry.attributes.position.needsUpdate = true;
                this.particles.geometry.attributes.scale.needsUpdate = true;
                this.renderer.render(this.scene, this.camera);
                this.count += 0.1;
            }
        }
    }
</script>
<style scoped>
  /*自定义滚动条*/ 
  .scrollbar { 
    overflow-x: auto; 
    overflow-y: auto; 
  } 
  .scrollbar::-webkit-scrollbar { 
    width: 0px; 
  } 
</style>
